import api from '@pu/js/plugins/api.js';

const store = {
    namespaced: true,
    state: {
        isModalOpen: false,
        modalType: '',
        subscriptions: [],
    },
    actions: {
        getSubscriptions({ state, commit }) {
            return new Promise((resolve, reject) => {
                if (state.subscriptions.length > 0) {
                    resolve();
                }

                api.get('/subscriptions?include=variations')
                    .then((res) => {
                        const responseItems = res.data.included
                            .slice(0, 3)
                            .sort((firstItem, secondItem) => firstItem.attributes.interval - secondItem.attributes.interval);

                        const shortestSubscriptionPrice = responseItems[0].attributes.price;
                        const shortestSubscriptionInterval = responseItems[0].attributes.interval;

                        const subscriptions = responseItems.map(({ attributes }, index) => {
                            return {
                                title: `${attributes.interval} Month Subscription`,
                                subtitle: getSubscriptionSubtitle(attributes.interval),
                                descriptionList: getSubscriptionDescriptionList(attributes.interval),
                                price: `$${Number(attributes.price) / Number(attributes.interval)}`,
                                pricePer: '/mo',
                                salvageSavings: formatSlavageOfferPrice(attributes.price, attributes.interval),
                                actionCaption: 'Sign Up Now',
                                url: attributes.checkoutUrl,
                                popular: index === 1,
                                mostSavings: index === 2,
                                interval: attributes.interval,
                            };
                        });

                        commit('saveSubscriptions', subscriptions);

                        resolve();
                    })
                    .catch((error) => {
                        reject();
                    });
            });
        },
    },
    mutations: {
        saveSubscriptions(state, payload) {
            state.subscriptions = payload;
        },
        openModal(state, type) {
            if (type) {
                state.modalType = type;
            }
            state.isModalOpen = true;
        },
        closeModal(state) {
            state.modalType = '';
            state.isModalOpen = false;
        },
    },
};

function formatSlavageOfferPrice(price, interval) {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const salvageSavingsPrice = formatter.format(Math.round(parseFloat(price) / Number(interval)) / 2);

    return salvageSavingsPrice;
}

function getSubscriptionSubtitle(interval) {
    const subtitles = {
        1: '',
        3: 'Save $12 by paying every 3 months.',
        6: 'Save $60 by paying every 6 months.',
    };

    return subtitles[interval];
}

function getSubscriptionDescriptionList(interval) {
    const descriptionList = {
        1: ['Personalized Onboarding', 'Month to month access'],
        3: ['90 Minutes Live Online Tutoring', 'Essay Review', 'Personalized Onboarding'],
        6: ['270 Minutes Live Online Tutoring', 'Essay Review', 'Personalized Onboarding'],
    };

    return descriptionList[interval];
}

export default store;
